
import NumberMixins from '@/mixins/NumberMixins'

export default {
  mixins: [NumberMixins],

  methods: {
    formatInt (row, col, value, index) {
      return this.formatInteger(value)
    },

    formatNum (row, col, value, index) {
      return this.formatNumber(value)
    },

    totalColumns (param, text = 'Totals', intArray = null, doubleArray = null, currencyArray = null, noTotals = null) {

      const { columns, data } = param
      const sums = []

      columns.forEach((column, index) => {

        if (index === 0) {
          sums[index] = text
          return
        }

        const values = data.map(item => Number(item[column.property]))

        if (!values.every(value => isNaN(value))) {

          sums[index] = values.reduce((prev, curr) => {

            const value = Number(curr)

            if (!isNaN(value)) {
              return prev + curr

            } else {
              return prev
            }

          }, 0)

        } else {
          sums[index] = null
        }
      })

      for (let i = 0; i < columns.length; i++) {
        if (noTotals && noTotals.includes(columns[i].property)) {
          sums[i] = null
        } else {

          if (intArray) {
            if (intArray.includes(columns[i].property)) {
              sums[i] = this.formatInteger(sums[i])
            }
          }

          if (doubleArray) {
            if (doubleArray.includes(columns[i].property)) {
              sums[i] = this.formatNumber(sums[i])
            }
          }

          if (currencyArray) {
            if (currencyArray.includes(columns[i].property)) {
              sums[i] = this.formatMoney(sums[i])
            }
          }
        }

      } // for

      return sums
    }

  } // methods

}
